import { Component, Injector } from "@angular/core";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { AddTeamWorkflowStepBaseComponent } from "../add-team-workflow-step-base.component";

@WorkflowStepComponent("adapt-add-team-confirm-step")
@Component({
    selector: "adapt-add-team-confirm-step",
    templateUrl: "./add-team-confirm-step.component.html",
    styleUrl: "./add-team-confirm-step.component.css",
    standalone: false,
})
export class AddTeamConfirmStepComponent extends AddTeamWorkflowStepBaseComponent {
    public teamLeaderLabel$ = this.teamsService.getTeamLeaderLabel$();
    public teamMembersLabel$ = this.teamsService.getTeamMemberLabelPlural$();

    public featureConfigItems: IConfigItem[] = [];

    public constructor(injector: Injector) {
        super(injector);
    }

    public workflowStepOnInit() {
        super.workflowStepOnInit();

        this.featureConfigItems = this.getActiveTeamConfigItems()
            .filter((item) => this.runData.createTeamBindingModel.teamFeatures.includes(item.featureName!));
    }
    
    public workflowStepNext() {
        return this.saveAndClose();
    }
}
